'use client';

import { APIProvider } from '@vis.gl/react-google-maps';

export function PlacesProvider({ children }: React.PropsWithChildren) {
  if (!process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY)
    throw new Error('Google Maps API key is not set');

  return (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY} libraries={['places']}>
      {children}
    </APIProvider>
  );
}
